import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal } from "react-icons/tb";
import { ValutField, ValutSelect } from "../../../Components/Atoms/ValutInput";
import { ModernFilterBar } from "../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersDateSection,
} from "../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_REFUNDS_FILTERS,
  buildRefundsFilterTags,
  exportRefundsCsv,
  hasActiveRefundsFilters,
  isRefundsChipFilterActive,
  removeRefundsFilterTag,
} from "./refundsFilters";

const RefundsMoreFiltersForm = ({ draft, onChange, subAccounts = [] }) => (
  <div className="extract-more-filters-form">
    <MoreFiltersDateSection draft={draft} onChange={onChange} />
    <MoreFiltersAmountSection draft={draft} onChange={onChange} idPrefix="refunds-more" />
    {Array.isArray(subAccounts) && subAccounts.length >= 1 && (
      <section className="extract-more-filters-form__section">
        <ValutField label={intl.get("extract.subAccount")} htmlFor="refunds-more-sub-account">
          <ValutSelect
            id="refunds-more-sub-account"
            value={draft.subAccountId}
            onChange={(event) => onChange({ ...draft, subAccountId: event.target.value })}
          >
            <option value="">{intl.get("common.all")}</option>
            {subAccounts.map((sa) => (
              <option key={sa.subAccountId} value={sa.subAccountId}>
                {sa.name}
              </option>
            ))}
          </ValutSelect>
        </ValutField>
      </section>
    )}
  </div>
);

export const RefundsFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
  subAccounts = [],
}) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isRefundsChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isRefundsChipFilterActive(filters, "amount"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return <AmountFilterPanel draft={draft} onChange={onChange} idPrefix="refunds-filter" />;
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_REFUNDS_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      moreFiltersActive={isRefundsChipFilterActive(filters, "more")}
      buildFilterTags={(currentFilters) => buildRefundsFilterTags(currentFilters, subAccounts)}
      hasActiveFilters={hasActiveRefundsFilters}
      removeFilterTag={removeRefundsFilterTag}
      onExport={exportRefundsCsv}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <RefundsMoreFiltersForm draft={draft} onChange={onChange} subAccounts={subAccounts} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
      }}
    />
  );
};
